<app-head></app-head>

<app-invoice-creator *ngIf="isCreating" (close)="isCreating=false"></app-invoice-creator>

<div class="main-container" *ngIf="!isCreating">
  <div class="top-container">
    <h2 style="font-family: 'Lato', sans-serif; font-weight: 900"> Factures </h2>
    <button mat-raised-button style="color: #16191e" (click)="isCreating=true">Créer une facture</button>
  </div>

  <div>
    <h5 style="font-family: 'Lato', sans-serif; font-weight: 600"> Liste des tous les factures</h5>
  </div>

  <div class="search-container">
    <form class="search">
      <button mat-icon-button>
        <mat-icon fontIcon="search"></mat-icon>
      </button>
      <input class="search-input" type="text" placeholder="Chercher une facture" #filter
             (keyup)="searchResults(filter.value)">
    </form>
  </div>

  <table>
    <colgroup>
      <col class="col-id"/>
      <col class="col-date"/>
      <col class="col-client"/>
      <col class="col-lien"/>
    </colgroup>
    <thead>
    <tr>
      <th>Numéro</th>
      <th>Date</th>
      <th>Client</th>
      <th>Télécharger</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let invoice of filteredInvoices">
      <td>{{ invoice.id }}</td>
      <td>
        {{ formatDateToMMDDYYYY(invoice.created_date) }}
      </td>
      <td>
        {{ invoice.client_name }}
      </td>
      <td>
        <button mat-icon-button
                [disabled]="!invoice.file_uri"
                (click)="downloadInvoice(invoice.uuid)"
                [matTooltip]="invoice.file_uri ? 'Télécharger la facture' : 'Aucun fichier disponible'">
          <mat-icon>file_download</mat-icon>
        </button>
      </td>
    </tr>
    </tbody>
  </table>

</div>
